// src/apps/auth/pages/Callback.tsx
import {useParams} from "react-router-dom";
import {useEffect} from "react";
import {useDispatch} from "react-redux";
import {AppDispatch} from "~/store";
import {authenticateShopify, verifyAuthenticatedUser} from "~/store/authSlice.ts";
import useAuthentication from "~/hooks/useAuthentication.ts";
import {Flex, Spinner, Text, useToast, VStack} from "@chakra-ui/react";
// import useExtendedNavigation from "~/hooks/useExtendedNavigation.ts";
import { getSessionToken } from "@shopify/app-bridge-utils";
import {useAppBridge} from "@shopify/app-bridge-react";

const Callback = () => {
    const {public_id} = useParams();
    const dispatch = useDispatch<AppDispatch>();
    // get all ? and & params from url
    const urlParams = new URLSearchParams(window.location.search);
    const params = Object.fromEntries(urlParams.entries());
    const {storeShopifySession, getShopifySession, redirectToApplication} = useAuthentication();
    const shopifySession = getShopifySession();
    const toast = useToast();
    // const navigate = useExtendedNavigation();
    const app = useAppBridge()
    console.log('GET TOKEN???');
    // @ts-ignore
    getSessionToken(app).then((r) => {
        console.log('TOKEN ???');
        console.log(r)
    })
    useEffect(() => {
        if(shopifySession && public_id) {
            console.log('Checking session');
            dispatch(verifyAuthenticatedUser(shopifySession)).unwrap().then(() => {
                redirectToApplication(public_id, params);
            }) .catch((e) => {
                toast({
                    title: 'Error',
                    description: 'There was an issue authenticating your store, please try again.',
                    status: 'error',
                    duration: 5000,
                    isClosable: true
                });
                console.log('Error verifying user');
                console.log(e)
                // navigate(`/app/${public_id}/login`);
            });
            return;
        }

        if(!params || !public_id) {
            return;
        }
        dispatch(authenticateShopify({
            public_id,
            params
        })).unwrap().then((r) => {
            console.log('storing shopify session');
            storeShopifySession(
                params?.shop || 'N/A',
                r.hmac,
                public_id,
                r.shopify_admin_url,
                r.app_name
            );
            redirectToApplication(public_id, params);
        }).catch((r) => {
            toast({
                title: 'Error',
                description: 'There was an issue authenticating your store, please try again.',
                status: 'error',
                duration: 5000,
                isClosable: true
            });
            console.log(r);
            // navigate(`/app/${public_id}/login`);
            console.log('Error authenticateShopify because of stored state ?');
        });
    }, [public_id]);

    return (
        <Flex
            minH="100vh"
            bg="gray.900"
            alignItems="center"
            justifyContent="center"
        >
            <VStack spacing={6}>
                <Spinner
                    size="xl"
                    thickness="4px"
                    color="blue.500"
                    emptyColor="gray.700"
                />
                <Text color="gray.100" fontSize="lg">
                    Verifying your request please wait...
                </Text>
            </VStack>
        </Flex>
    )
}

export default Callback;